import React from 'react'
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Login from '../Components/Auth/Login';
import PublicRouters from './PublicRouter';
import PrivateRouters from './PrivateRouter';
import { getCookie } from '../Helpers/Utils';
import AuthenticateProvider from '../Context/AuthenticateProvider';
import AddStaff from '../Components/Staff/Add';
import StaffList from '../Components/Staff/List';
import EditStaff from '../Components/Staff/Update';
import AddFarmer from '../Components/Farmer/Add';
import EditFarmer from '../Components/Farmer/Update';
import FarmerList from '../Components/Farmer/List';
import StaffDeposit from '../Components/Deposit/Deposit';
import AddPurchase from '../Components/Purchase/Add';
import PurchaseList from '../Components/Purchase/List';
import AddExpense from '../Components/Expenses/Add';
import AddProduct from '../Components/Products/Add';
import EditProduct from '../Components/Products/Update';
import InventoryList from '../Components/Products/List';
import AddClient from '../Components/Clients/Add';
import ClientList from '../Components/Clients/List';
import EditClient from '../Components/Clients/Update';
import CottonCalculator from '../Components/KandiCalculator';
import AddLorry from '../Components/Vehicles/Add';
import LorryList from '../Components/Vehicles/List';
import EditLorry from '../Components/Vehicles/Update';
import InvoiceCreate from '../Components/Invoices/Add';
import InvoiceList from '../Components/Invoices/List';
import EditInvoice from '../Components/Invoices/Update';
import PaymentList from '../Components/Payments/List';
import PaymentModal from '../Components/Payments/PaymentModal';
import CreatePayment from '../Components/Payments/Add';
import CreditNoteCreate from '../Components/Credit/Add';
import CreditNoteList from '../Components/Credit/List';
import Dashboard from '../Components/Reports/Dashboard';
import InventoryReport from '../Components/Reports/Inventory';
import InvoiceReport from '../Components/Reports/Invoice';
import PaymentReport from '../Components/Reports/Payments';
import CreditNoteReport from '../Components/Reports/Creditnote';
import PurchaseReport from '../Components/Reports/Purchase';
import StaffWelcome from '../Components/StaffWelcome';
import ExpenseList from '../Components/Expenses/List';
import AddInvoiceTDS from '../Components/Tds/Add';
import InvoiceTDSList from '../Components/Tds/List';
import EditInvoiceTDS from '../Components/Tds/Update';
import AddStaffSalary from '../Components/Salary/Add';
import StaffSalaryList from '../Components/Salary/List';
import EditStaffSalary from '../Components/Salary/Update';
import AgentPaymentCreate from '../Components/AgentPay/Add';
import AgentPaymentList from '../Components/AgentPay/List';
import EditPurchase from '../Components/Purchase/Update';
import CreatePurchasePayment from '../Components/Purchase/Pay';
import InwardManagement from '../Components/Purchase/PayList';
import ProfitLossReport from '../Components/Reports/ProfitLoss';
import SalaryAnalyticsReport from '../Components/Reports/Salary';
import StaffWalletReport from '../Components/Reports/Staff';
import SalesReportDashboard from '../Components/Reports/Sales';
import StaffDepositHistory from '../Components/Deposit/List';
import ForgotPassword from '../Components/Auth/Forget';
import EditExpense from '../Components/Expenses/Update';
import AddAdminExpense from '../Components/Expenses/AdminAdd';
import CreditNoteView from '../Components/Credit/View';
import CreditNoteUpdate from '../Components/Credit/Update';
import InvoiceView from '../Components/Invoices/View';
import PurchaseReceiptView from '../Components/Purchase/View';
import SubClient from '../Components/Clients/SubClient';
import SubClientCreate from '../Components/Clients/SubAdd';
import SubClientList from '../Components/Clients/SubClient';
import EditSubClient from '../Components/Clients/SubUpdate';
import EditPayment from '../Components/Purchase/PayUpdate';

const index = () => {
  return (
    <React.Fragment>
      <AuthenticateProvider>
        <Router>
          <Routes>
            <Route element={<PublicRouters />}>
              <Route path="/login" element={<Login />} />
              <Route path="/forget-password" element={<ForgotPassword />} />

            </Route>
            <Route element={<PrivateRouters />}>
              <Route path="/" element={<StaffWelcome />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/inventory/report" element={<InventoryReport />} />
              <Route path="/invoices/report" element={<InvoiceReport />} />
              <Route path="/creditnotes/report" element={<CreditNoteReport />} />
              <Route path="/payments/report" element={<PaymentReport />} />
              <Route path="/purchases/report" element={<PurchaseReport />} />
              <Route path="/profitloss/report" element={<ProfitLossReport />} />
              <Route path="/salary/report" element={<SalaryAnalyticsReport />} />
              <Route path="/staff/report" element={<StaffWalletReport />} />
              <Route path="/sales/report" element={<SalesReportDashboard />} />
              <Route path="/staffs" element={<StaffList />} />
              <Route path="/staffs/add" element={<AddStaff />} />
              <Route path="/staffs/:id" element={<EditStaff />} />
              <Route path="/farmers" element={<FarmerList />} />
              <Route path="/farmers/add" element={<AddFarmer />} />
              <Route path="/farmers/:id" element={<EditFarmer />} />
              <Route path="/deposit" element={<StaffDepositHistory />} />
              <Route path="/deposit/add" element={<StaffDeposit />} />
              <Route path="/purchases" element={<PurchaseList />} />
              <Route path="/purchases/add" element={<AddPurchase />} />
              <Route path="/purchases/pay" element={<CreatePurchasePayment />} />
              <Route path="/purchases/pay/:id" element={<EditPayment />} />
              <Route path="/purchases/paylist" element={<InwardManagement />} />
              <Route path="/purchases/report" element={<PurchaseReport />} />
              <Route path="/purchases/:id" element={<EditPurchase />} />
              <Route path="/purchases-view/:id" element={<PurchaseReceiptView />} />
              <Route path="/expenses" element={<ExpenseList />} />
              <Route path="/expenses/add" element={<AddExpense />} />
              <Route path="/expenses/admin" element={<AddAdminExpense />} />
              <Route path="/expenses/:id" element={<EditExpense />} />
              <Route path="/staffs/:id" element={<EditStaff />} />
              <Route path="/staffs/:id" element={<EditStaff />} />
              <Route path="/products" element={<InventoryList />} />
              <Route path="/products/add" element={<AddProduct />} />
              <Route path="/products/:id" element={<EditProduct />} />
              <Route path="/clients" element={<ClientList />} />
              <Route path="/sub-clients" element={<SubClientList />} />
              <Route path="/clients/add" element={<AddClient />} />
              <Route path="/sub-clients/add" element={<SubClientCreate />} />
              <Route path="/clients/:id" element={<EditClient />} />
              <Route path="/sub-clients/:id" element={<EditSubClient />} />
              <Route path="/vehicles" element={<LorryList />} />
              <Route path="/vehicles/add" element={<AddLorry />} />
              <Route path="/vehicles/:id" element={<EditLorry />} />
              <Route path="/invoices" element={<InvoiceList />} />
              <Route path="/invoices/add" element={<InvoiceCreate />} />
              <Route path="/invoices/:id" element={<EditInvoice />} />
              <Route path="/invoices-view/:id" element={<InvoiceView />} />
              <Route path="/payments" element={<PaymentList />} />
              <Route path="/payments/add" element={<CreatePayment />} />
              <Route path="/payments/:id" element={<EditInvoice />} />
              <Route path="/creditnotes" element={<CreditNoteList />} />
              <Route path="/creditnotes/add" element={<CreditNoteCreate />} />
              <Route path="/creditnotes/:id" element={<CreditNoteUpdate />} />
              <Route path="/creditnotes-view/:id" element={<CreditNoteView />} />
              <Route path="/tds" element={<InvoiceTDSList />} />
              <Route path="/tds/:id" element={<EditInvoiceTDS />} />
              <Route path="/tds/add" element={<AddInvoiceTDS />} />
              <Route path="/salary" element={<StaffSalaryList />} />
              <Route path="/salary/add" element={<AddStaffSalary />} />
              <Route path="/salary/:id" element={<EditStaffSalary />} />
              <Route path="/agent-pay/add" element={<AgentPaymentCreate />} />
              <Route path="/agent-pay" element={<AgentPaymentList />} />
              <Route path="/calculator" element={<CottonCalculator />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Route>
          </Routes>
        </Router>
      </AuthenticateProvider>
    </React.Fragment>
  )
}

export default index
